<!--
 * @Description:  外部人员导入选择
 * @Author: liuwp
 * @Date: 2022-09-21 17:48:11
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-29 17:16:50
-->
<template>
  <section>
    <yxt-drawer
      :destroy-on-close="true"
      size="960px"
      :title="$t('pc_ac_lbl_outer_management').d('游客管理')"
      :visible.sync="showExernalDrawer"
      :before-close="done => done(false)"
      @closed="closeDrawer"
    >
      <external-select
        ref="externalSelect"
        :activity-id="activityId"
        :selected="selected"
      ></external-select>
      <div v-if="inStage" slot="footer">
        <yxt-button @click="closeDrawer">
          {{ $t('pc_ac_btn_cancel').d('取消') }}
        </yxt-button>
        <yxt-button type="primary" @click="submit">
          {{ $t('pc_ac_btn_sure').d('确定') }}
        </yxt-button>
      </div>
    </yxt-drawer>
  </section>
</template>
<script>
import externalSelect from './component/externalSelect.vue';
export default {
  name: 'ApaasExternalPersonnelSelect',
  name_zh: '活动中心游客管理',
  components: {
    externalSelect
  },
  eventList: [
    // 组件里抛出的事件名，需要开发者自己梳理
    {
      type: 'submit', // 具体的抛出的事件名
      handler: 'handleExternalSubmit', // 事件处理函数
      label: '游客管理保存成功' // 事件描述
    },
    {
      type: 'update:showExernalDrawer', // 具体的抛出的事件名
      handler: 'handleShowExernalDrawer', // 事件处理函数
      label: '游客管理抽屉收起' // 事件描述
    }
  ],
  props: {
    showExernalDrawer: {
      type: Boolean,
      default: false,
      desc: '是否展示游客管理抽屉',
      setter: 'BooleanSetter'
    },
    activityId: {
      type: String,
      default: '',
      desc: '活动的id',
      setter: 'TextSetter'
    },
    inStage: {
      type: Boolean,
      default: false,
      desc: '是否在阶段中',
      setter: 'BooleanSetter'
    },
    selected: {
      type: Array,
      default: null,
      desc: '选中的游客',
      setter: 'JsonSetter'
    }
  },
  // props: ['showExernalDrawer', 'activityId', 'inStage', 'selected'],
  provide() {
    return {
      inStage: this.inStage,
      activityId: this.activityId
    };
  },
  methods: {
    closeDrawer() {
      this.$emit('update:showExernalDrawer', false);
    },
    submit() {
      this.$emit('submit', this.$refs.externalSelect.multipleSelection);
      this.$emit('update:showExernalDrawer', false);
    },
    loadData() {
      this.$refs.externalSelect.outerListGet();
    }
  }
};
</script>
